import React from 'react'
import { ProgressBar } from 'react-bootstrap'

const Loading = () => <ProgressBar active color="info" now={100} />

export default Loading
